'use client';

import { useEffect } from 'react';
import { posthogTracker } from '@/utils/trackingPostHog';

export const GeminiClinicViewTracker = () => {
  useEffect(() => {
    posthogTracker.captureViewClinicGemini();
  }, []);

  return null;
};
